import { custom } from 'devextreme/ui/dialog';

export type ConflictChoice = 'overwrite' | 'keepBoth' | 'skip' | 'cancel';

export type OnConflictPolicy = 'Overwrite' | 'KeepBoth';

let batchPolicy: ConflictChoice | null = null;
let batchCancelled = false;

export function resetTransferBatchState(): void {
  batchPolicy = null;
  batchCancelled = false;
}

export function isTransferBatchCancelled(): boolean {
  return batchCancelled;
}

export function conflictChoiceToPolicy(choice: ConflictChoice): OnConflictPolicy | null {
  if (choice === 'overwrite') return 'Overwrite';
  if (choice === 'keepBoth') return 'KeepBoth';
  return null;
}

export async function resolveFileConflict(itemName: string, destinationHint?: string): Promise<ConflictChoice> {
  if (batchCancelled) return 'cancel';
  if (batchPolicy && batchPolicy !== 'cancel') return batchPolicy;

  const location = destinationHint ? ` in ${destinationHint}` : '';
  const messageHtml = `<strong>"${escapeHtml(itemName)}"</strong> already exists${escapeHtml(location)}.<br><br>What would you like to do?<br><br><label style="display:flex;align-items:center;gap:0.35rem;margin-top:0.5rem;"><input type="checkbox" class="jarvis-conflict-apply-all" /> Apply to all remaining items</label>`;

  let applyToAll = false;

  const dialog = custom({
    title: 'File already exists',
    messageHtml,
    buttons: [
      {
        text: 'Replace',
        type: 'default',
        stylingMode: 'contained',
        onClick: () => {
          applyToAll = document.querySelector<HTMLInputElement>('.jarvis-conflict-apply-all')?.checked ?? false;
          return { choice: 'overwrite' as ConflictChoice, applyToAll };
        }
      },
      {
        text: 'Keep both',
        stylingMode: 'outlined',
        onClick: () => {
          applyToAll = document.querySelector<HTMLInputElement>('.jarvis-conflict-apply-all')?.checked ?? false;
          return { choice: 'keepBoth' as ConflictChoice, applyToAll };
        }
      },
      {
        text: 'Skip',
        stylingMode: 'outlined',
        onClick: () => ({ choice: 'skip' as ConflictChoice, applyToAll: false })
      },
      {
        text: 'Cancel',
        stylingMode: 'text',
        onClick: () => ({ choice: 'cancel' as ConflictChoice, applyToAll: false })
      }
    ]
  });

  const result = (await dialog.show()) as { choice: ConflictChoice; applyToAll: boolean } | undefined;
  const choice = result?.choice ?? 'cancel';

  if (choice === 'cancel') {
    batchCancelled = true;
    return 'cancel';
  }

  if (result?.applyToAll && choice !== 'skip') {
    batchPolicy = choice;
  }

  return choice;
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
